import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  clearNipState,
  getSingleNipApplication,
} from "../../../redux/Actions/NipOnboardingActions";
import NipWrapper2 from "../../Nip/NipWrapper2";
import Storage from "../../../utils/storage";
import Spinner from "react-spinner-material";
import { mapStateToProps } from "./Nip-Doc-Upload/mapStateToProps";
import { getRequiredDocs } from "../../../redux/Actions/GetDocsActions";
import Application from "./IntegrationHome/Application";

const SingleIntegration = (props) => {
  const {
    isGetting,
    getSuccess,
    applications,
    managerId,
    sendSuccess,
    requestSuccess,
    getRequiredDocs,
    docs,
    getApplication,
    clearNipState,
  } = props;

  const appId = props.location.state && props.location.state.id;

  useEffect(
    () => {
      clearNipState();
      getApplication(appId);
    },
    // eslint-disable-next-line
    [getApplication]
  );

  useEffect(
    () => {
      if (getSuccess) {
        const type = "nip";
        getRequiredDocs(type);
      }
    },
    // eslint-disable-next-line
    [getSuccess]
  );

  useEffect(() => {
    if (sendSuccess) {
      getApplication(appId);
    }
  },
  // eslint-disable-next-line
  [appId, sendSuccess, getApplication]);

  useEffect(() => {
    if (requestSuccess) {
      getApplication(appId);
    }
  },
  // eslint-disable-next-line
  [appId, requestSuccess, getApplication]);

  const [state, setState] = useState({
    kit: true,
    selectType: false,
    docUpload: false,
    permitForm: false,
    shareKeys: false,
    runTest: false,
  });

  const selectType = selectTypeFunc(setState);
  const docUpload = docUploadFunc(setState);
  const ipPermitForm = ipPermitFormFunc(setState);
  const shareKeys = shareKeysFunc(setState);
  const runTests = runTestsFunc(setState);
  const kitDownload = Storage.get("kit-download");
  const selectIntType = Storage.get("select-type");
  const kitDownloadStatus = (trail) =>
    trail ? trail.downloaded_kit : kitDownload;
  const selectIntTypeStatus = (trail) =>
    trail ? trail.selected_integration_type : selectIntType;
  const uploadStartStatus = Storage.get("upload-start");
  const uploadFinishStatus = (trail) =>
    !trail ? false : trail.document_upload;
  const nipTrail = applications && applications[0] && applications[0].nip_trail;
  const ipFormStatus = (trail) => trail && trail.ip_form_submission;
  const publicKeyStatus = (trail) => trail && trail.shared_public_key;
  const runTestStatus = (trail) => trail && trail.run_test;
  const scheduleMigrationStatus = (trail) => trail && trail.schedule_migration;
  const docApproval = (trail) => trail && trail.nip_document_approval;
  const requestManager = (trail) => trail && trail.network_manager_request;
  const ipPermitApproval = (trail) => trail && trail.ip_permit_approval;
  const testApproval = (trail) => trail && trail.test_approval;
  const migrationApproval = (trail) => trail && trail.migration_approval;
  const docApproved = Storage.get("docApproved");
  const startIpSubmission = Storage.get("startIpSubmission");
  const migrationStart = Storage.get("migrationStart");

  return (
    <NipWrapper2 currentRoute={`/nip/integration/${appId}`}>
      {isGetting ? (
        <div className="center-spinner2">
          <Spinner
            size={120}
            color={"#047558"}
            spinnerwidth={5}
            visible={true}
          />
        </div>
      ) : getSuccess ? (
        <Application
          applications={applications}
          state={state}
          selectType={selectType}
          docApproved={docApproved}
          ipPermitForm={ipPermitForm}
          docUpload={docUpload}
          kitDownloadStatus={kitDownloadStatus(nipTrail)}
          selectIntTypeStatus={selectIntTypeStatus(nipTrail)}
          uploadStartStatus={uploadStartStatus}
          uploadFinishStatus={uploadFinishStatus(nipTrail)}
          ipFormStatus={ipFormStatus(nipTrail)}
          publicKeyStatus={publicKeyStatus(nipTrail)}
          runTestStatus={runTestStatus(nipTrail)}
          scheduleMigrationStatus={scheduleMigrationStatus(nipTrail)}
          docApproval={docApproval(nipTrail)}
          requestManager={requestManager(nipTrail)}
          ipPermitApproval={ipPermitApproval(nipTrail)}
          testApproval={testApproval(nipTrail)}
          migrationApproval={migrationApproval(nipTrail)}
          docs={docs}
          getSingleApplication={() => getApplication(appId)}
          startIpSubmission={startIpSubmission}
          shareKeys={shareKeys}
          managerId={managerId}
          runTests={runTests}
          migrationStart={migrationStart}
        />
      ) : (
        <div className="nip-error">
          <p>Error fetching trail</p>
        </div>
      )}
    </NipWrapper2>
  );
};

SingleIntegration.propTypes = {
  applications: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  clearNipState: PropTypes.func,
  docs: PropTypes.any,
  getApplication: PropTypes.func,
  getRequiredDocs: PropTypes.func,
  getSuccess: PropTypes.any,
  isGetting: PropTypes.any,
  location: PropTypes.shape({
    state: PropTypes.shape({
      id: PropTypes.any,
    }),
  }),
  managerId: PropTypes.any,
  requestSuccess: PropTypes.any,
  sendSuccess: PropTypes.any,
};

const mapDispatchToProps = (dispatch) => ({
  getApplication: (id) => dispatch(getSingleNipApplication(id)),
  getRequiredDocs: (type) => dispatch(getRequiredDocs(type)),
  clearNipState: () => dispatch(clearNipState()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SingleIntegration);

function runTestsFunc(setState) {
  return () => {
    setState({
      kit: false,
      selectType: false,
      docUpload: false,
      permitForm: false,
      shareKeys: false,
      runTest: true,
    });
  };
}

function shareKeysFunc(setState) {
  return (data) => {
    Storage.set("data", JSON.stringify(data));
    Storage.set("startIpSubmission", true);
    setState({
      kit: false,
      selectType: false,
      docUpload: false,
      permitForm: false,
      shareKeys: true,
      runTest: false,
    });
  };
}

function ipPermitFormFunc(setState) {
  return () => {
    Storage.set("docApproved", true);
    setState({
      kit: false,
      selectType: false,
      docUpload: false,
      permitForm: true,
      shareKeys: false,
      runTest: false,
    });
  };
}

function docUploadFunc(setState) {
  return (selection) => {
    Storage.set("select-type", true);
    Storage.set("selection", selection);
    Storage.set("upload-start", true);
    setState({
      kit: false,
      selectType: false,
      docUpload: true,
      permitForm: false,
      shareKeys: false,
      runTest: false,
    });
  };
}

function selectTypeFunc(setState) {
  return () => {
    Storage.set("kit-download", true);
    setState({
      kit: false,
      selectType: true,
      docUpload: false,
      permitForm: false,
      shareKeys: false,
      runTest: false,
    });
  };
}
